import { replaceRoute } from '../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import SubHeader from '../../components/SubHeader.jsx';
import {
  retrieveProject,
  selectProject,
  updateProject,
} from '../../modules/projects.js';
import { mapFinalFormErrors } from '../../lib/utils.js';
import { changeStrategySettingsValidate } from './utils/index.js';
import ChangeStrategySettingsHeader from '../../components/headers/PageHeaders/Project/ChangeStrategy/ChangeStrategySettingsHeader.jsx';
import ChangeStrategySettingsFrom from '../../components/projects/ChangeStrategy/ChangeStrategySettingsForm.jsx';
import {
  retrieveChangeStrategy,
  updateChangeStrategyCustomFields,
} from '../../modules/changeStrategy.js';

const mapErrors = mapFinalFormErrors('Failed to save');

const mapStateToProps = (state, ownProps) => ({
  projectId: ownProps.projectId,
  project: selectProject(ownProps.projectId)(state),
});

const mapDispatchToProps = {
  retrieveProject,
  updateProject,
  retrieveChangeStrategy,
  updateChangeStrategyCustomFields,
};

function ChangeStrategySettingsFormContainer(props) {
  const {
    slug,
    projectId,
    project,
    retrieveProject,
    retrieveChangeStrategy,
    updateProject,
    updateChangeStrategyCustomFields,
  } = props;

  const [columns, setColumns] = useState(null);

  const randomId = () => Math.random().toString(36).slice(2, 7);
  const redirectToChangeStrategy = () =>
    replaceRoute('projects/change-strategy', { projectId });

  const onSubmit = (values) => {
    const underscoreFilter = () =>
      columns
        .filter((column) => column.name)
        .map((column) => {
          column.name = column.name.replace(/_/g, '-');
          return column;
        });

    updateChangeStrategyCustomFields(projectId, {
      changeStrategyFields: underscoreFilter(),
    })
      .then((res) => redirectToChangeStrategy())
      .catch(mapErrors);
  };

  const validate = (values) => changeStrategySettingsValidate(values, columns);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((item, index) => ({ ...item, priority: index }));
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) return;

    const items = reorder(
      columns,
      result.source.index,
      result.destination.index
    );

    setColumns(items);
  };

  const onCreateColumn = () =>
    setColumns([
      ...columns,
      {
        id: null,
        editor: false,
        priority: columns.length,
        name: '',
        allowDelete: true,
        allowEditor: true,
        draggableId: randomId(),
        tableShow: true,
      },
    ]);

  const onDeleteColumn = (draggableId) => {
    const { name } = columns.find(
      (column) => column.draggableId === draggableId
    );
    if (
      !window.confirm(
        'Are you sure you want to delete this column? All data in the column will be deleted as well.'
      )
    )
      return;

    setColumns(columns.filter((column) => column.draggableId !== draggableId));
  };

  const onColumnNameChange = (value, itemIndex) => {
    setColumns(
      columns.map((item, index) =>
        itemIndex === index ? { ...item, name: value } : item
      )
    );
  };

  const onContentTypeChange = (itemIndex) => {
    if (
      columns[itemIndex].editor &&
      columns[itemIndex].id &&
      project.changeStrategyFields[itemIndex].editor &&
      !window.confirm(
        'Are you sure you want to change the field type? Text formatting will be lost.'
      )
    )
      return;

    setColumns(
      columns.map((item, index) =>
        itemIndex === index ? { ...item, editor: !item.editor } : item
      )
    );
  };

  const onTableShowChange = (itemIndex) => {
    setColumns(
      columns.map((item, index) =>
        itemIndex === index ? { ...item, tableShow: !item.tableShow } : item
      )
    );
  };

  useEffect(() => {
    retrieveProject(projectId, false);
    retrieveChangeStrategy(projectId);
  }, []);

  useEffect(() => {
    project &&
      setColumns(
        project.changeStrategyFields.map((item) => ({
          ...item,
          draggableId: item.draggableId || randomId(),
        }))
      );
  }, [project]);

  return (
    <React.Fragment>
      {project && (
        <ChangeStrategySettingsHeader project={project} slug={slug} />
      )}
      <SubHeader flexJustify small>
        <h2>Customize Change Strategy</h2>
      </SubHeader>

      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  {columns ? (
                    <Form
                      component={ChangeStrategySettingsFrom}
                      onSubmit={onSubmit}
                      validate={validate}
                      onDragEnd={onDragEnd}
                      onCreateColumn={onCreateColumn}
                      onColumnNameChange={onColumnNameChange}
                      onDeleteColumn={onDeleteColumn}
                      onContentTypeChange={onContentTypeChange}
                      onTableShowChange={onTableShowChange}
                      data={columns}
                      slug={slug}
                      projectId={projectId}
                    />
                  ) : null}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeStrategySettingsFormContainer);
